import * as $ from 'jquery';
// show toast if message exist
if ($('#globalToast .toast-text').text().trim().length > 0) {
    $('#globalToast').toast({
        delay: 8000
    }).toast('show');
}
export default undefined;
